function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState, mapMutations } from 'vuex'
// import utils from '@/js/utils'
import audiencias_service from '../services/audiencias_service';
import { LIST_ROLES, LIST_DOMAINS, ROLES_LIST } from '@/js/constants';
import tasks from '@/js/tasks';
import { mapState } from "vuex";
// import segmentos_service from '../services/segmentos_service'
// import domain_service from '@/apps/data-platform/services/master_data/domain_service'
// import analytics_audience_service from '../services/analytics_audience_service'
// import Somos1BudgetUpload from '@/apps/customer-insigths/components/Somos1BudgetUpload'
/*
|---------------------------------------------------------------------
| Board Page
|---------------------------------------------------------------------
|
| Kanban board page component with the logic to display and manage
| cards
|
*/
export default {
  components: {},
  props: {
    info: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    is_audience: {
      type: Boolean,
      required: true,
      default: function _default() {
        return true;
      }
    },
    list_to_paginate: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    list_images: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    list_images_new: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    image: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // time in milliseconds to define when the sorting should start
      // list_to_paginate: [],
      // list_images: [],
      // list_images_new: [],
      localListImagesNew: [],
      pagination: {
        current: 1,
        total: 0,
        limit: 12
      },
      key_table: 1,
      // image: { description: '' },
      // custom_audience_id: null,
      // audience: {},
      int_is_audience: false,
      item_selected: {},
      item_selected_new: {},
      key_images: {},
      // size_page: 8,
      exampleContent: 'This is TEXT',
      canvas: null,
      bounds: null,
      img2: null,
      back_image: null,
      isDragging: false,
      imgPosX: 0,
      imgPosY: 0,
      offsetX: 0,
      offsetY: 0,
      newImageHeight: 512,
      newImageWidth: 512,
      resolutions: [{
        id: [512, 512],
        name: 'Original 1024x1024'
      }, {
        id: [540, 540],
        name: 'Instagram 1080x1080'
      }, {
        id: [470, 384],
        name: 'Facebook Post 940x768'
      }, {
        id: [360, 240],
        name: 'Google 720x480'
      }],
      resolution_x: 512,
      resolution_y: 512,
      textEditorVisible: false,
      texto: '',
      fuente: 'Arial',
      tamanoFuente: 12,
      color: 'black',
      x: 50,
      y: 50,
      draggingText: false,
      fuentes: ['Arial', 'Verdana', 'Helvetica', 'Tahoma', 'Trebuchet MS', 'Times New Roman', 'Georgia', 'Garamond', 'Courier New', 'Brush Script MT', 'Lucida Sans', 'Palatino', 'Bookman', 'Avant Garde', 'Gill Sans', 'Century Gothic', 'Franklin Gothic', 'Andale Mono', 'Arial Black', 'Comic Sans MS', 'Impact', 'Lucida Console', 'Lucida Grande', 'Lucida Sans Unicode', 'Microsoft Sans Serif', 'Monaco', 'MS Serif', 'MS Sans Serif', 'Symbol', 'System', 'Wingdings', 'Zapf Dingbats'],
      tamanosFuente: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 72],
      selected: false,
      cornerSize: 10
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    // ...mapState('data-platform', ['companyCode', 'orgs']),
    // ...mapState('audience', ['audience_helper', 'gpt_images', 'audience_images']),
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers_list_images: function headers_list_images() {
      return [{
        text: this.traductor('aud.config.images_list.description'),
        value: 'description'
      },
      // { text: this.traductor('aud.config.images_list.state'), value: 'state' },
      {
        text: this.traductor('aud.config.images_list.creation_user'),
        value: 'creation_user'
      }, {
        text: this.traductor('aud.config.images_list.total'),
        value: 'total',
        align: 'center'
      }, {
        text: this.traductor('aud.config.images_list.actions'),
        value: 'actions'
      }];
    },
    filtros: function filtros() {
      return {
        empresa: this.traductor('filtros.empresa'),
        nombre: this.traductor('filtros.nombre'),
        plataforma: this.traductor('filtros.plataforma'),
        estado: this.traductor('filtros.estado'),
        rango: this.traductor('filtros.rango')
      };
    },
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    },
    dateRangeText2: function dateRangeText2() {
      return this.filters.fechas_end ? this.filters.fechas_end.join(' ~ ') : '';
    },
    getOrgs: function getOrgs() {
      var _orgs = [{
        value: null,
        text: '.: Selecciones un registro :.'
      }];
      this.orgs.forEach(function (x) {
        _orgs.push({
          value: x.code,
          text: x.domain
        });
      });
      return _orgs;
    },
    isAudienceAdmin: function isAudienceAdmin() {
      return window.userInfo.userRoles.includes(ROLES_LIST.AUDIENCE_ADMIN);
    },
    isOrgDataManagement: function isOrgDataManagement() {
      return window.userInfo.userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD);
    },
    isAudienceAnalyst: function isAudienceAnalyst() {
      return window.userInfo.userRoles.includes(ROLES_LIST.AUDIENCE_ANALYST);
    }
  }),
  watch: {
    cards: function cards(val) {
      return this.parse(val);
    },
    list_images_new: {
      immediate: true,
      handler: function handler(newValue) {
        this.localListImagesNew = Array.isArray(newValue) ? _toConsumableArray(newValue) : [];
      }
    }
  },
  created: function created() {
    this.render();
  },
  mounted: function mounted() {
    this.int_is_audience = this.is_audience ? 1 : 0;
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    // getAudienceById() {
    //   audiencias_service.getAudienceById({ custom_audience_id: this.custom_audience_id })
    //     .then(response => {
    //       if (response.status) {
    //         this.audience = response.data
    //         this.audience.custom_audience_description = response.data.custom_audience_description
    //         this.audience.segment_name = response.data.segment_name
    //         this.audience.segment_size = response.data.segment_size
    //         this.audience.segment_code = response.data.segment_code
    //         this.estados = response.data.estados
    //         this.key_table += 1
    //         this.image.description = '' + this.audience.custom_audience_description
    //         this.getListImages(response.data.id)
    //       }
    //     })
    // },
    // getListImages(audience_id) {
    //   this.list_images = []
    //   this.list_to_paginate = []
    //   audiencias_service.getListImages(audience_id)
    //     .then(response => {
    //       response.data.forEach(x => {
    //         x.details.forEach(img => {
    //           const item = {
    //             description: x.description,
    //             id_audience: x.id_audience,
    //             creation_user: x.creation_user,
    //             creation_date: x.creation_date,
    //             ...img
    //           }
    //           this.key_images[item.id] = item.id + '_' + 1
    //           // if (this.audience_images[item.filename_storage]) {
    //           item.src = audiencias_service.getBaseUrl() + '/audience-images/image-view/' + item.filename_storage
    //           item.type = '64'
    //           item.download = true
    //           item.state = 2
    //           this.key_images[item.id] = item.id + '_' + 1
    //           // }
    //           // this.list_images.push(item)
    //           this.list_to_paginate.push(item)
    //         })
    //       })
    //       this.nextImages()
    //       // this.onViewOthers(0)
    //       this.pagination.total = response.data.length
    //     })
    // },
    // nextImages() {
    //   if (this.list_images.length >= this.list_to_paginate.length) {
    //     return
    //   }
    //   const from = this.list_images.length
    //   let nextSize = this.list_to_paginate.length - this.list_images.length
    //   nextSize = nextSize > this.size_page ? this.size_page : nextSize
    //   const to = from + nextSize
    //   for (let i = from; i < to; i++) {
    //     this.list_images.push(this.list_to_paginate[i])
    //     this.list_images_new.push(this.list_to_paginate[i])
    //   }
    // },
    onChangeState: function onChangeState(item, state, is_audience) {
      audiencias_service.changeState(item.id, state, is_audience).then(function (response) {
        if (response.status) {
          item.state = state;
          // tasks.toast.success('La acción se ha realizado correctamente.')
        } else {
          tasks.toast.error('No se ha podido realizar los cambios.');
        }
      });
    },
    onViewImage: function onViewImage(item) {
      var _this = this;
      if (item.src) {
        this.item_selected = Object.assign({}, item);
        this.$refs['modal_imagen'].onOpen();
      } else {
        audiencias_service.downloadImage(item.id_audience, item.filename_storage, 1).then(function (response) {
          if (response.status == true) {
            item.src = response.data;
            item.type = '64';
            item.download = true;
            _this.item_selected = Object.assign({}, item);
            _this.$refs['modal_imagen'].onOpen();
          }
        });
      }
      setTimeout(function () {
        _this.canvas = _this.$refs.nameOfCanvas;
        _this.bounds = _this.canvas.getBoundingClientRect();
        _this.ctx = _this.canvas.getContext('2d');
        _this.ctx.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
        _this.render();
      }, 1000);
    },
    onViewImageNew: function onViewImageNew(item) {
      var _this2 = this;
      if (item.src) {
        this.item_selected_new = Object.assign({}, item);
      } else {
        audiencias_service.downloadImage(item.id_audience, item.filename_storage, 1).then(function (response) {
          if (response.status == true) {
            item.src = response.data;
            item.type = '64';
            item.download = true;
            _this2.item_selected_new = Object.assign({}, item);
          }
        });
      }
    },
    selectItem: function selectItem(item) {
      if (item.state === 2) {
        this.onChangeState(item, 1, this.int_is_audience);
        this.list_to_paginate.unshift(item);
        this.list_images.unshift(item);
      } else if (item.state === 1) {
        this.onChangeState(item, 2, this.int_is_audience);
        var index = this.list_images.indexOf(item);
        this.list_images.splice(index, 1);
        var _index = this.list_to_paginate.indexOf(item);
        this.list_to_paginate.splice(_index, 1);
      }
    },
    onDownloadImage: function onDownloadImage(item) {
      var _this3 = this;
      if (item.src) {
        this.clickDownloadImage(item);
      } else {
        audiencias_service.downloadImage(item.id_audience, item.filename_storage, 1).then(function (response) {
          if (response.status == true) {
            item.src = response.data;
            item.type = '64';
            item.download = true;
            _this3.clickDownloadImage(item);
          }
        });
      }
    },
    b64toBlob: function b64toBlob(b64Data) {
      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, {
        type: contentType
      });
      return blob;
    },
    onViewOthers: function onViewOthers(index) {
      var _this4 = this;
      if (this.list_images.length <= index) {
        return;
      }
      if (this.audience_images[this.list_images[index].filename_storage]) {
        this.list_images[index].src = this.audience_images[this.list_images[index].filename_storage];
        this.list_images[index].type = '64';
        this.list_images[index].download = true;
        this.key_images[this.list_images[index].id] = this.list_images[index].id + '_' + 1;
        this.onViewOthers(index + 1);
      } else {
        audiencias_service.downloadImage(this.list_images[index].id_audience, this.list_images[index].filename_storage, false, 1).then(function (response) {
          if (response.status == true) {
            // var url = "data:image/png;base64," + response.data
            var blob = _this4.b64toBlob(response.data, 'image/png');
            var blobUrl = URL.createObjectURL(blob);
            _this4.list_images[index].src = blobUrl;
            _this4.list_images[index].type = '64';
            _this4.list_images[index].download = true;
            _this4.$store.commit('audience/setAudienceImages', {
              key: _this4.list_images[index].filename_storage,
              value: blobUrl
            });
          }
          _this4.key_images[_this4.list_images[index].id] = _this4.list_images[index].id + '_' + 1;
          _this4.onViewOthers(index + 1);
        });
      }
    },
    clickDownloadImage: function clickDownloadImage(item) {
      /* var a = document.createElement("a"); //Create <a>
      a.href = item.src; //Image Base64 Goes here
      a.download = item.filename_storage.split("/")[1]; //File name Here
      a.click(); //Downloaded file
      */
      tasks.lockScreen.lock();
      fetch(item.src).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        tasks.lockScreen.unlock();
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = item.filename_storage.split('/')[1];
        link.click();
      }).catch(function (err) {
        tasks.lockScreen.unlock();
      });
    },
    onGenerateImageFirst: function onGenerateImageFirst() {
      this.$refs['modal_generate'].onOpen();
      // this.item_selected_new = {}
      // this.list_images_new = []
      this.onGenerateImage();
    },
    onGenerateImageAgain: function onGenerateImageAgain() {
      this.onGenerateImage();
    },
    onGenerateImage: function onGenerateImage() {
      var _this5 = this;
      if (!this.companyCode) {
        return;
      }
      this.item_selected_new = {};
      this.localListImagesNew = [];
      var body = {
        'prompt': this.image.description,
        'n': 4,
        'size': '1024x1024',
        'id_audiencia': this.info.id,
        'is_audience': this.is_audience,
        'company_code': this.companyCode
      };
      audiencias_service.generateImage(body).then(function (response) {
        console.log(response);
        if (response.status) {
          tasks.lockScreen.lock();
          response.data.forEach(function (item) {
            var image = {
              description: _this5.image.description,
              filename_storage: item.filename_storage,
              type: '64',
              id: item.id,
              state: 2,
              src: audiencias_service.getBaseUrl() + '/audience-images/image-view/' + item.filename_storage,
              download: true,
              audience_id: item.audience_id
            };
            // this.list_to_paginate.unshift(image)
            // this.list_images.unshift(image)
            _this5.localListImagesNew.unshift(image);
          });
          tasks.lockScreen.unlock();
          // this.item_selected = Object.assign({}, image)
          // this.$refs['modal_imagen'].onOpen()
          // this.getAudienceById()
          // this.$refs['modal_imagen'].onOpen()
        } else {
          tasks.toast.info(response.message);
          _this5.$refs['modal_generate'].onClose();
        }
      });
    },
    onDeleteImage: function onDeleteImage(item) {
      var _this6 = this;
      audiencias_service.deleteImage(item.id, this.int_is_audience).then(function (response) {
        if (response.status) {
          var index = _this6.list_images.indexOf(item);
          _this6.list_images.splice(index, 1);
          var _index = _this6.list_to_paginate.indexOf(item);
          _this6.list_to_paginate.splice(_index, 1);
        }
      });
    },
    onVolver: function onVolver() {
      this.audience_helper.viewed = true;
      this.$store.commit('audience/setAudienceHelper', this.audience_helper);
      this.$router.push({
        name: 'link_list_audiences',
        query: {
          viewed: this.info.id
        }
      });
    },
    render: function render() {
      var _this7 = this;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.back_image = new Image();
      this.back_image.crossOrigin = 'anonymous';
      this.back_image.src = this.item_selected.src;
      // this.drawBackground()
      this.canvas.addEventListener('mousedown', this.handleMouseDown);
      this.canvas.addEventListener('mouseup', this.handleMouseUp);
      this.canvas.addEventListener('mousemove', this.handleMouseMove);
      this.back_image.onload = function () {
        console.log(_this7.item_selected.src);
        _this7.ctx.drawImage(_this7.back_image, 0, 0, _this7.canvas.width, _this7.canvas.height);
        _this7.drawImageOnCanvas();
        _this7.drawText();
      };
    },
    handleFileChange: function handleFileChange(event) {
      var _this8 = this;
      this.textEditorVisible = false;
      var file = event;
      var reader = new FileReader();
      reader.onload = function (e) {
        _this8.img2 = new Image();
        _this8.img2.crossOrigin = 'anonymous';
        _this8.img2.src = e.target.result;
        _this8.img2.onload = function () {
          _this8.img2.width = _this8.img2.width / 2;
          _this8.img2.height = _this8.img2.height / 2;
          _this8.drawImageOnCanvas();
          _this8.drawText();
        };
      };
      reader.readAsDataURL(file);
    },
    drawImageOnCanvas: function drawImageOnCanvas() {
      if (!this.img2) return;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawBackground();
      this.ctx.drawImage(this.img2, this.imgPosX, this.imgPosY, this.img2.width, this.img2.height);
    },
    drawBackground: function drawBackground() {
      this.ctx.drawImage(this.back_image, 0, 0, this.newImageWidth, this.newImageHeight);
    },
    handleMouseDown: function handleMouseDown(e) {
      var mousePos = this.getMousePosition(e);
      var mouseX = mousePos.x;
      var mouseY = mousePos.y;
      if (this.img2) {
        if (mouseX >= this.imgPosX && mouseX <= this.imgPosX + this.img2.width && mouseY >= this.imgPosY && mouseY <= this.imgPosY + this.img2.height) {
          this.isDragging = true;
          this.selected = true;
          this.offsetX = mouseX - this.imgPosX;
          this.offsetY = mouseY - this.imgPosY;
        } else {
          this.selected = false;
        }
      }
      if (this.selected) {
        console.log('selected');
        this.drawResizeCorners();
        this.drawOutline();
      }
      var textMetrics = this.ctx.measureText(this.texto);
      var textWidth = textMetrics.width;
      var textHeight = this.tamanoFuente;
      if (mouseX > this.x && mouseX < this.x + textWidth && mouseY > this.y - textHeight && mouseY < this.y) {
        console.log('dentro');
        this.draggingText = true;
        this.offsetX = mouseX - this.x;
        this.offsetY = mouseY - this.y;
      }
      console.log('mouseDown');
    },
    handleMouseUp: function handleMouseUp() {
      this.isDragging = false;
      this.draggingText = false;
      this.selected = false;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawImageOnCanvas();
      this.drawText();
    },
    handleMouseMove: function handleMouseMove(e) {
      var mousePos = this.getMousePosition(e);
      // console.log(mousePos.x)
      // console.log(mousePos.y)
      var mouseX = mousePos.x;
      var mouseY = mousePos.y;
      if (this.draggingText) {
        console.log('moviendo');
        this.x = mouseX - this.offsetX;
        this.y = mouseY - this.offsetY;
        this.drawText();
      }
      if (this.isDragging) {
        this.imgPosX = mouseX - this.offsetX;
        this.imgPosY = mouseY - this.offsetY;
        this.drawImageOnCanvas();
        this.drawResizeCorners();
        this.drawOutline();
        this.drawText();
      } else {
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        // drawSquare(x, y, size_X, size_Y);
        if (!this.img2) {
          return;
        }
        if (mouseX >= this.imgPosX && mouseX <= this.imgPosX + this.img2.width && mouseY >= this.imgPosY && mouseY <= this.imgPosY + this.img2.height) {
          this.canvas.style.cursor = 'move';
        } else {
          this.canvas.style.cursor = 'default';
        }
      }
    },
    getMousePosition: function getMousePosition(evt) {
      var rect = this.canvas.getBoundingClientRect();
      return {
        x: Math.round(evt.clientX - rect.left),
        y: Math.round(evt.clientY - rect.top)
      };
    },
    DownloadDesign: function DownloadDesign() {
      var downloadCanvas = document.createElement('canvas');
      downloadCanvas.width = this.resolution_x * 2;
      downloadCanvas.height = this.resolution_y * 2;
      var downloadContext = downloadCanvas.getContext('2d');
      var canvasRatio = downloadCanvas.width / downloadCanvas.height;
      var imageRatio = this.back_image.width / this.back_image.height;
      var newImageWidth, newImageHeight;
      if (canvasRatio > imageRatio) {
        newImageWidth = downloadCanvas.width;
        newImageHeight = downloadCanvas.width / imageRatio;
      } else {
        newImageWidth = downloadCanvas.height * imageRatio;
        newImageHeight = downloadCanvas.height;
      }
      var offsetX = (downloadCanvas.width - newImageWidth) / 2;
      var offsetY = (downloadCanvas.height - newImageHeight) / 2;
      downloadContext.drawImage(this.back_image, 0, 0, this.back_image.width, this.back_image.height, offsetX, offsetY, newImageWidth, newImageHeight);
      if (this.img2) {
        downloadContext.drawImage(this.img2, this.imgPosX * 2, this.imgPosY * 2, this.img2.width * 2, this.img2.height * 2);
      }
      if (this.texto) {
        downloadContext.font = "".concat(this.tamanoFuente * 2, "px ").concat(this.fuente);
        downloadContext.fillStyle = this.color;
        downloadContext.fillText(this.texto, this.x * 2, this.y * 2);
      }

      // Convert the canvas to a data URL and create a download link
      var dataURL = downloadCanvas.toDataURL('image/jpeg');
      var downloadLink = document.createElement('a');
      downloadLink.href = dataURL;
      downloadLink.download = 'imagen_' + downloadCanvas.width + 'x' + downloadCanvas.height + '.jpg';

      // Click the download link to initiate the download
      downloadLink.click();
    },
    changeResolution: function changeResolution(item) {
      var _this9 = this;
      this.textEditorVisible = false;
      console.log(item);
      console.log(item.id[0]);
      this.resolution_x = item.id[0];
      this.resolution_y = item.id[1];
      this.canvas = null;
      this.bounds = null;
      this.img2 = null;
      this.isDragging = false;
      this.imgPosX = 0;
      this.imgPosY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
      this.canvas = this.$refs.nameOfCanvas;
      this.bounds = this.canvas.getBoundingClientRect();
      this.ctx = this.canvas.getContext('2d');
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      var canvasRatio = this.resolution_x / this.resolution_y;
      var imageRatio = this.back_image.width / this.back_image.height;
      if (canvasRatio > imageRatio) {
        this.newImageWidth = this.resolution_x;
        this.newImageHeight = this.resolution_x / imageRatio;
      } else {
        this.newImageWidth = this.resolution_y * imageRatio;
        this.newImageHeight = this.resolution_y;
      }
      var tempCanvas = document.createElement('canvas');
      tempCanvas.width = this.newImageWidth;
      tempCanvas.height = this.newImageHeight;
      var tempCtx = tempCanvas.getContext('2d');
      tempCtx.drawImage(this.back_image, 0, 0, this.newImageWidth, this.newImageHeight);
      var croppedImage = document.createElement('img');
      croppedImage.src = tempCanvas.toDataURL();
      croppedImage.onload = function () {
        _this9.back_image.width = _this9.resolution_x;
        _this9.back_image.height = _this9.resolution_y;
        _this9.back_image.src = croppedImage.src;
        _this9.render();
      };
      this.img2 = new Image();
    },
    cambiarTamanoFuente: function cambiarTamanoFuente() {
      // Lógica para cambiar el tamaño de fuente en el editor de texto
      console.log('Tamaño de fuente seleccionado:', this.tamanoFuente);
      this.drawText();
    },
    noFilter: function noFilter() {
      return true;
    },
    // aumentarFuente() {
    //   this.tamanoFuente += 2
    //   this.drawText()
    // },
    // reducirFuente() {
    //   this.tamanoFuente -= 2
    //   this.drawText()
    // },
    drawText: function drawText() {
      this.canvas = this.$refs.nameOfCanvas;
      this.bounds = this.canvas.getBoundingClientRect();
      this.ctx = this.canvas.getContext('2d');
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      if (this.img2) {
        this.drawImageOnCanvas();
      } else {
        this.drawBackground();
      }
      this.ctx.font = "".concat(this.tamanoFuente, "px ").concat(this.fuente);
      this.ctx.fillStyle = this.color;
      this.ctx.fillText(this.texto, this.x, this.y);
    },
    drawOutline: function drawOutline() {
      this.ctx.beginPath();
      this.ctx.rect(this.imgPosX, this.imgPosY, this.img2.width, this.img2.height);
      this.ctx.strokeStyle = 'green';
      this.ctx.lineWidth = 2;
      this.ctx.stroke();
    },
    drawResizeCorners: function drawResizeCorners() {
      for (var i = 0; i < 4; i++) {
        console.log(i);
        var cornerX = this.imgPosX + (i % 2 === 0 ? -this.cornerSize / 2 : this.img2.width - this.cornerSize / 2);
        var cornerY = this.imgPosY + (i < 2 ? -this.cornerSize / 2 : this.img2.height - this.cornerSize / 2);
        this.ctx.beginPath();
        this.ctx.rect(cornerX, cornerY, this.cornerSize, this.cornerSize);
        this.ctx.fillStyle = 'green';
        this.ctx.fill();
      }
    },
    nextImages: function nextImages() {
      this.$emit('child-clicked');
    }
  }
};